// extracted by mini-css-extract-plugin
module.exports = {"menu":"MenuList_menu__2G_TQ","submenu":"MenuList_submenu__21pTB","isOpen":"MenuList_isOpen__3hi3p"};